<div class="contact-service-row">
    <div class="flex-container contact-service-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <div *ngIf="contact.isPaid" class="contact-service-row-icons">
                <fa-icon (click)="print()" [icon]="['fas', 'print']" [styles]="{'color': '#9469a2'}" size="lg"></fa-icon>
            </div>
            <div *ngIf="!contact.isPaid" class="contact-service-row-icons">
                <fa-icon *ngIf="!contact.isValidated" (click)="validate()" [icon]="['fas', 'check-double']" [styles]="{'color': '#9469a2'}" size="lg"></fa-icon>
                <fa-icon (click)="edit()" [icon]="['fas', 'euro-sign']" class="edit-icon" size="lg"></fa-icon>
                <fa-icon *ngIf="contact.isValidated" (click)="pay()" [icon]="['fas', 'cash-register']" [styles]="{'color': '#9469a2'}" size="lg"></fa-icon>
            </div>
            <div *ngIf="collapsed">
              <div *ngFor="let code of codes">{{code.code}}</div>
            </div>
            <div *ngIf="!collapsed">
              <table mat-table [dataSource]="codes" class="full-width">
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef> Code </th>
                    <td mat-cell *matCellDef="let code">
                      {{code.code}}&nbsp;&nbsp;
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="label">
                    <th mat-header-cell *matHeaderCellDef> Libellé </th>
                    <td mat-cell *matCellDef="let code">
                      {{code.label | htmlEntities}}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
        </div>
    </div>
</div>
